import React, { Component } from 'react';
import { resolvePublicAssets } from '../../../../utils';
import './style.scss';

interface CustomerProfileTitleProps {
  customerTitle: string;
}

interface CustomerProfileTitleState {}

class CustomerProfileTitle extends Component<
  CustomerProfileTitleProps,
  CustomerProfileTitleState
> {
  componentDidMount() {}

  render() {
    const { customerTitle } = this.props;
    return <div className="customer-profile-title">{customerTitle}</div>;
  }
}

export default CustomerProfileTitle;
